import React, { FC } from 'react'
import { useTheme } from 'react-jss'
import { LightTheme } from '../theme'
import { IconProps } from './types'

export const Phase1: FC<IconProps> = (props) => {
  const theme: LightTheme = useTheme()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <circle
        opacity="0.2"
        cx="16"
        cy="16"
        r="16"
        fill={props.fill || theme.colors.blue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 7H9C7.9 7 7 7.9 7 9V23C7 24.1 7.9 25 9 25H23C24.1 25 25 24.1 25 23V9C25 7.9 24.1 7 23 7ZM23 9V23H9V9H23ZM18 21H16V13H14V11H18V21Z"
        fill={props.fill || theme.colors.blue}
      />
    </svg>
  )
}
